import React from 'react';
import { Spin } from '@douyinfe/semi-ui';

const Loading = ({ prompt: name = 'page' }) => {
  return (
    <div style={{ 
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '200px',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <Spin size="large" />
      <div style={{ 
        color: '#909399',
        fontSize: '14px'
      }}>
        加载{name}中...
      </div>
    </div>
  );
};

export default Loading;
